import { getEnv } from 'mobx-easy';
import { RootEnv } from '../helpers/create-store';
import { RealTimeSendAck } from './realtime-service';

/**
 * Tracks the "watch ..." subscriptions registered by one owner (a store instance), so that owner
 * can unwatch exactly its own claims - see {@link RealTimeService.watch} for why a stable caller
 * identity is needed.
 */
export default class RealtimeWatchTracker {
	private readonly callerId: symbol;

	/** Best-effort mirror of what this tracker asked the service to watch, tagged with the service's {@link RealTimeService.generation} at registration time so {@link disposeAll} can tell a real subscription from one `init()` already invalidated behind this tracker's back - never treat this list itself as proof a subscription is still live. */
	private watches: Array<{ eventName: string; payload: unknown; generation: number }> = [];

	constructor(name: string) {
		this.callerId = Symbol(name);
	}

	watch(eventName: string, payload: unknown, ack?: RealTimeSendAck) {
		const { realTimeService } = getEnv<RootEnv>();

		if (ack) {
			realTimeService.watch(eventName, payload, this.callerId, ack);
		} else {
			realTimeService.watch(eventName, payload, this.callerId);
		}
		this.watches.push({ eventName, payload, generation: realTimeService.generation });
	}

	disposeAll() {
		const { realTimeService } = getEnv<RootEnv>();

		this.watches
			.filter(({ generation }) => generation === realTimeService.generation)
			.forEach(({ eventName, payload }) => realTimeService.unwatch(eventName, payload, this.callerId));
		this.watches = [];
	}
}
